export type KnuulaContractResult =
  | { found: true; url: string }
  | { found: false };

export async function fetchKnuulaContract(jobIdx: number): Promise<KnuulaContractResult> {
  const resp = await fetch(`/api/knuula-contract?jobIdx=${encodeURIComponent(jobIdx)}`, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store',
  });

  if (!resp.ok) return { found: false };

  try {
    const json = await resp.json();
    const link = Array.isArray(json) ? json[0]?.LINK : json?.LINK;
    if (link && typeof link === 'string') return { found: true, url: link };
    return { found: false };
  } catch {
    return { found: false };
  }
}